import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {AutomatService} from '../services/automat.service';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {environment} from '../../environments/environment';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { AddAutomatComponent } from '../add-automat/add-automat.component';
import { EditAutomatComponent } from '../edit-automat/edit-automat.component';

declare var $: any;

@Component({
    selector: 'app-all-automats',
    templateUrl: './all-automats.component.html',
    styleUrls: ['./all-automats.component.css']
})
export class AllAutomatsComponent implements OnInit {

    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('closeNoteModal') closeNoteModal: ElementRef;
    public firmId: string;
    onMouseOver: boolean;
    mouseOverAutomat: string;
    onMouseOverFirm: boolean;
    mouseOverFirm: string;
    public firm = {name: '', _id: ''};
    public searchText = '';
    public automats = [];
    public totalAutomats = 0;
    public automatsFirstDeactive = [];
    public automatsSecondsActive = [];
    public lat: any;
    public lng: any;
    repeater: any;
    ngbModalOptions: NgbModalOptions;
    filter: number = -1;
    public selectedDevice = {name: '', mac: '', vpnIpAddress: ''};
    public selectedBeacon = {name: ''};
    public selectedModem = {mark: ''};
    public selectedSim = {serial: '', phoneNumber: ''};
    public selectedVPos = {name: ''};
    public infoDesc = {infoDescription: '', _id: ''};
    public selectDesc: any;
    public ModelImagePath = '';

    selector: string = '.all-automats-list';
    page = 1;
    pages = 2;

    constructor(
                private automatService: AutomatService,
                private modalService: NgbModal,
                private router: Router, private spinner: NgxSpinnerService) {
        this.repeater = window.setInterval(() => $('#refresh').click(), 60000 * 1);
        this.ModelImagePath = environment.AutomatImagePath;
    }

    ngOnInit() {
        this.spinner.show();
        this.getAllAutomats();
    }

    getAllAutomats() {
        this.automatService.getAllAutomats(this.page, {name: this.searchText, status: this.filter}).subscribe(res => {
            this.automatsFirstDeactive = [];
            this.automatsSecondsActive = [];
            this.pages = res.pages;
            this.totalAutomats = res.total;
            res.docs.forEach(data => {
                if (data._id !== '' && data._id !== null && data._id !== undefined) {                    
                    if (!this.compareDate(data.device && data.device.lastInformed)) {
                        this.automatsFirstDeactive.push(data);
                    } else {
                        this.automatsSecondsActive.push(data);
                    }
                }
            });
            if (this.automats.length === 0) {
                this.automats = this.automatsFirstDeactive.concat(this.automatsSecondsActive);
            } else {
                this.automats.push(this.automatsFirstDeactive.concat(this.automatsSecondsActive));
            }
            this.onScroll();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });

    }

    searchAutomats() {
        this.page = 1;
        this.automatService.getAllAutomats(this.page, {name: this.searchText, status: this.filter}).subscribe(res => {
            this.automats = [];
            this.automatsFirstDeactive = [];
            this.automatsSecondsActive = [];
            this.pages = res.pages;
            this.totalAutomats = res.total;
            res.docs.forEach(data => {
                if (data._id !== '' && data._id !== null && data._id !== undefined) {                    
                    if (!this.compareDate(data.device && data.device.lastInformed)) {
                        this.automatsFirstDeactive.push(data);
                    } else {
                        this.automatsSecondsActive.push(data);
                    }
                }
            });
            if (this.automats.length === 0) {
                this.automats = this.automatsFirstDeactive.concat(this.automatsSecondsActive);
            } else {
                this.automats.push(this.automatsFirstDeactive.concat(this.automatsSecondsActive));
            }
            if (this.page === 1) {
                this.onScroll();
            }
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        }); 
    }

    startMarquee(automatId: string) {
        this.mouseOverAutomat = automatId;
        this.onMouseOver = true;
    }

    stopMarquee(automatId: string) {
        this.mouseOverAutomat = automatId;
        this.onMouseOver = false;
    }
    startFirmMarquee(automatId: string) {
        this.mouseOverFirm = automatId;
        this.onMouseOverFirm = true;
    }

    stopFirmMarquee(automatId: string) {
        this.mouseOverFirm = automatId;
        this.onMouseOverFirm = false;
    }

    compareDate(lastInformed: Date) {
        const date1 = new Date(lastInformed).getTime();
        const date2 = new Date().getTime();
        const time = date2 - date1;
        const minutesDiff = time / (60 * 1000);
        if (minutesDiff <= 4) {
            return true;
        } else {
            return false;
        }
    }

    openAddAutomatModal() {
        this.ngbModalOptions = {
            centered: true,
            size: 'lg',
            keyboard: true,
            backdrop: true
        };
        const modalRef = this.modalService.open(AddAutomatComponent,this.ngbModalOptions);
    }

    selected(id: string, firmId: string, firm: string) {
        localStorage.setItem('firmId', firmId);
        localStorage.setItem('firm', firm);
        localStorage.setItem('which', 'all');
        localStorage.setItem('selectAutomat', id);
        this.ngbModalOptions = {
            centered: true,
            size: 'lg',
            keyboard: true,
            backdrop: true
        };
        const modalRef = this.modalService.open(EditAutomatComponent,this.ngbModalOptions);
    }

    deleteAutomat(id: string) {
        this.spinner.show();
        this.automatService.deleteAutomat(id).subscribe(res => {
            this.getAllAutomats();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }
    selectedInfo(automat) {
        this.selectedDevice = automat.device;
        this.selectedBeacon = automat.beacon;
        this.selectedModem = automat.modem;
        this.selectedSim = automat.sim;
        this.selectedVPos = automat.vPos;
    }
    getLocations(coordinates: any) {
        this.lat = coordinates[0];
        this.lng = coordinates[1];
    }


    getInfoDescriptions(id: string) {
        this.spinner.show();
        this.selectDesc = id;
        this.automatService.getInfoDescription(id).subscribe(res => {
            this.infoDesc = res;
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    UpdateDescription(infoDescription: string) {
        this.spinner.show();
        const data = { infoDescription : infoDescription };
        this.automatService.updateDescription(data, this.selectDesc).subscribe(res => {
            this.infoDesc = res;
            this.closeNoteModal.nativeElement.click();
            this.successSwal.show();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
                this.successSwal.show();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    filterAutomats(filter) {
        this.page = 1;
        this.filter = filter;
        switch (filter) {
            case 0:
                this.automats = [];
                this.getAllAutomats();
                break;
            case 1:
                this.automats = [];
                this.getAllAutomats();
                break;
            case 8:
                this.automats = [];
                this.getAllAutomats();
                break;
            case 9:
                this.automats = [];
                this.getAllAutomats();
                break;
        }
    }
    onScroll() {
        if (this.page + 1 > this.pages) { return; }
        $('#page-loader').fadeIn();
        this.page += 1;
        this.automatService.getAllAutomats(this.page, {name: this.searchText, status: this.filter})
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    if (item._id !== '' && item._id !== null && item._id !== undefined) {
                        this.automats.push(item);
                    }
                }
                this.pages = response.pages;
                this.totalAutomats = response.total;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/all-automats/all-automats.component.ts